import { render, staticRenderFns } from "./FileAnswer.vue?vue&type=template&id=6ce31d77"
import script from "./FileAnswer.vue?vue&type=script&lang=js"
export * from "./FileAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports